module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "root"
  }, [_c('div', {
    staticClass: "countdown"
  }, [_c('div', {
    staticClass: "timer"
  }, [_c('div', {
    staticClass: "time-box"
  }, [_c('div', {
    staticClass: "time-container"
  }, [_c('div', {
    staticClass: "digit"
  }, [_vm._v(_vm._s(_vm.days[0]))]), _vm._v(" "), _c('div', {
    staticClass: "digit"
  }, [_vm._v(_vm._s(_vm.days[1]))])]), _vm._v(" "), _c('p', [_vm._v("Days")])]), _vm._v(" "), _c('div', {
    staticClass: "time-box"
  }, [_c('div', {
    staticClass: "time-container"
  }, [_c('div', {
    staticClass: "digit"
  }, [_vm._v(_vm._s(_vm.hours[0]))]), _vm._v(" "), _c('div', {
    staticClass: "digit"
  }, [_vm._v(_vm._s(_vm.hours[1]))])]), _vm._v(" "), _c('p', [_vm._v("Hours")])]), _vm._v(" "), _c('div', {
    staticClass: "time-box"
  }, [_c('div', {
    staticClass: "time-container"
  }, [_c('div', {
    staticClass: "digit"
  }, [_vm._v(_vm._s(_vm.minutes[0]))]), _vm._v(" "), _c('div', {
    staticClass: "digit"
  }, [_vm._v(_vm._s(_vm.minutes[1]))])]), _vm._v(" "), _c('p', [_vm._v("Minutes")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8c59f422"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/CountdownTimer.vue
// module id = 929
// module chunks = 117